import Vue from "vue";
import { Avatar } from "element-ui";
import { Button } from "element-ui";
import { Input } from "element-ui";
import { Select } from "element-ui";
import { Option } from "element-ui";
import { OptionGroup } from "element-ui";
import { Checkbox } from "element-ui";
import { CheckboxGroup } from "element-ui";
import { Dropdown } from "element-ui";
import { DropdownMenu } from "element-ui";
import { DropdownItem } from "element-ui";
import { Calendar } from "element-ui";
import { Timeline } from "element-ui";
import { TimelineItem } from "element-ui";
import { Slider } from "element-ui";
import { Switch } from "element-ui";
import { Tag } from "element-ui";
import { Radio } from "element-ui";
import { Dialog } from "element-ui";
import { MessageBox } from "element-ui";
import { Message } from "element-ui";
import { DatePicker } from "element-ui";
import { RadioGroup } from "element-ui";
import { TimeSelect } from "element-ui";
import { Collapse, CollapseItem } from "element-ui";
import { Pagination } from "element-ui";
import { Form } from "element-ui";
import { FormItem } from "element-ui";
import { Row } from "element-ui";
import { Col } from "element-ui";
import { InputNumber } from "element-ui";
import { Tabs } from "element-ui";
import { TabPane } from "element-ui";
import { Table } from "element-ui";
import { TableColumn } from "element-ui";
import { Upload } from "element-ui";
import { Divider } from "element-ui";
import { RadioButton } from "element-ui";
import { Alert } from "element-ui";
import { Loading } from "element-ui";
import { Tooltip } from "element-ui";

import lang from "element-ui/lib/locale/lang/es";
import locale from "element-ui/lib/locale";

locale.use(lang);

Vue.use(Avatar);
Vue.use(DatePicker);
Vue.use(Button);
Vue.use(Input);
Vue.use(Select);
Vue.use(Option);
Vue.use(OptionGroup);
Vue.use(Checkbox);
Vue.use(CheckboxGroup);
Vue.use(Dropdown);
Vue.use(DropdownMenu);
Vue.use(DropdownItem);
Vue.use(Calendar);
Vue.use(Timeline);
Vue.use(TimelineItem);
Vue.use(Slider);
Vue.use(Switch);
Vue.use(Tag);
Vue.use(Radio);
Vue.use(Dialog);
Vue.use(RadioGroup);
Vue.use(TimeSelect);
Vue.use(Collapse);
Vue.use(CollapseItem);
Vue.use(Pagination);
Vue.use(Form);
Vue.use(FormItem);
Vue.use(Row);
Vue.use(Col);
Vue.use(InputNumber);
Vue.use(Tabs);
Vue.use(TabPane);
Vue.use(Table);
Vue.use(TableColumn);
Vue.use(Upload);
Vue.use(Divider);
Vue.use(RadioButton);
Vue.use(Alert);
Vue.use(Loading.directive);
Vue.use(Tooltip);

Vue.prototype.$message = Message;
Vue.prototype.$msgbox = MessageBox;
Vue.prototype.$alert = MessageBox.alert;
Vue.prototype.$confirm = MessageBox.confirm;
Vue.prototype.$prompt = MessageBox.prompt;
